import { HrPaths } from "@/modules/hr"

export const generateHrPath = (path: string) => {
  return `${HrPaths.HR.replace("*", "")}${path}`
}
